import { NgModule } from "@angular/core";
import { SharedModule } from "@shared/shared.module";
import { RoutesRoutingModule } from "./routes-routing.module";

import { HomeComponent } from "./components/home/home.component";
import { UserInfoComponent } from "./components/core/user-info/user-info.component";
import { AppInfoComponent } from "./components/core/app-info/app-info/app-info.component";
import {
  UserAdministrationComponent,
  DialogRemoveUserComponent,
  DialogAddUserComponent,
  DialogEditUserComponent,
} from "./components/admin/user-management/user-administration.component";
import { AdminFunctionsComponent } from "./components/admin/admin-functions/admin-functions.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { ReportsComponent } from "./components/reports/reports-voucher.component";

const COMPONENTS = [
  HomeComponent,
  DashboardComponent,
  UserInfoComponent,
  AppInfoComponent,
  UserAdministrationComponent,
  DialogRemoveUserComponent,
  DialogAddUserComponent,
  DialogEditUserComponent,
  AdminFunctionsComponent,
  ReportsComponent
];
const COMPONENTS_DYNAMIC = [];

@NgModule({
    imports: [SharedModule, RoutesRoutingModule],
    declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC]
})
export class RoutesModule {}
